(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("workHistoryHistoryLearner", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/learnerAccess/learningItemType/history/workHistoryHistoryLearnerView.html",
            controller: ["frameworkService", "assignmentLearnerAccessWorkHistoryResource", "$state", "messageService", "$uibModal", workHistoryHistoryLearnerCtrl],
            controllerAs: "vm"
        };
        function workHistoryHistoryLearnerCtrl(frameworkService, assignmentLearnerAccessWorkHistoryResource, $state, messageService, $uibModal) {
            var vm = this;
            vm.number = $state.params.number;
            vm.version = $state.params.version;
            vm.code = $state.params.code;
            vm.isWorkHoursEnabled = frameworkService.data.tenant.tenantFeaturesWorkHistoryHoursEnabled;
            vm.hideEvaluatorId = frameworkService.data.tenant.tenantFeaturesHideEvaluatorId;
            assignmentLearnerAccessWorkHistoryResource.getLearnerAccessHistoryViewModel({ number: vm.number, version: vm.version, code: vm.code }, function (result) {
                vm.model = result;
                vm.loaded = true;
            }, function (error) {
                messageService.error(error);
            });
            vm.viewDetails = function (attempt) {
                $uibModal.open({
                    templateUrl: "app/account/learnerAccess/learningItemType/history/workHistoryLearnerAccessAttemptDetails.html",
                    controller: ["attempt", function (attempt) {
                            var vm = this;
                            vm.attempt = attempt;
                            vm.viewAsHtml = function (text, title) {
                                $uibModal.open({
                                    templateUrl: "instructions.html",
                                    controller: ["data", function (data) {
                                            var vm = this;
                                            vm.body = data.modelBody;
                                            vm.title = data.modalTitle;
                                        }],
                                    controllerAs: "vm",
                                    animation: false,
                                    resolve: {
                                        data: function () {
                                            return { modalTitle: title, modelBody: text };
                                        }
                                    }
                                }).result.catch(angular.noop);
                            };
                        }],
                    controllerAs: "vm",
                    resolve: {
                        attempt: attempt
                    }
                }).result.catch(angular.noop);
            };
        }
    });
}());
